import "owl.carousel";

const templateAbout = {
  init: function () {
    this.slider();
  },

  slider: function () {
    var timeline_slider = $(".timeline__slider");

    timeline_slider.owlCarousel({
      nav: false,
      dots: false,

      navContainer: ".timeline__nav",
      navText: [
        '<svg xmlns="http://www.w3.org/2000/svg" width="9.866" height="16" viewBox="0 0 9.866 16"><path d="M1.867,0,0,1.867,6.133,8,0,14.133,1.867,16l8-8Z" transform="translate(9.867 16) rotate(180)"/></svg>',
        '<svg xmlns="http://www.w3.org/2000/svg" width="9.866" height="16" viewBox="0 0 9.866 16"><path d="M1.867,0,0,1.867,6.133,8,0,14.133,1.867,16l8-8Z"/></svg>',
      ],

      responsiveClass: true,
      responsive: {
        0: {
          items: 1,
        },
        600: {
          items: 2,
        },
        900: {
          items: 3,
        },
      },
    });

    timeline_slider.on("translate.owl.carousel", function () {
      $(".timeline__touch-icon").hide();
    });
  },
};

export default templateAbout;
